'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var affiliateApi = exports.affiliateApi = {
  title: 'API for Affiliates',
  description: 'Get access to all content on Tutellus and make money on every sale, with an easy to use API Rest.',
  get_access: 'Access the API',
  get_access_title: 'Get access to the documentation',
  reasons_title: 'Advantages of being an Affiliate',
  full_catalog_title: 'All the courses in the platform',
  full_catalog_description: 'Get access to our entire catalogue and add courses to your site as you like',
  powerful_title: 'Customizable, versatile Endpoint',
  powerful_description: 'Filter by Category, Topic, Teacher, Price, and more.',
  profits_title: 'A 50% share for you. Always',
  profits_description: 'For each user buying a course or certificate.',
  analytics_title: 'Real-time metrics on your Dashboard',
  analytics_description: 'Find which certificates and courses are the most profitable.',
  become_affiliate: 'Become an Affiliate',
  metrics_title: 'Metrics at your service',
  metrics_description: 'You will get a Dashboard to evaluate your work, measuring the most relevant metrics: Visits, Clicks, Profits and much more.',
  livetest_title: 'Try it now!',
  livetest_description: 'The code below obtains the courses from Tutellus and prints the list of titles and their URLs.',
  features_title: 'An Affiliate system clearer and more profitable than you can imagine',
  filtering_title: 'Advanced segmentation',
  filtering_description: 'Find the best courses for your specific audience, filtering through a multitude of parameters, levels and categories.',
  big_data_title: 'Big Data at your disposal',
  big_data_description: 'Our algorithms will monitor traffic, clicks, users and sales in real-time, displaying everything in your Dashboard.',
  leads_title: 'Earn money with every sale',
  leads_description: 'You will get 50% from any purchase made by a user who reached the product using your Affiliate link in the last 30 days.',
  terms: 'Terms and General Conditions of the Affiliate API',
  choose_a_language: 'Pick your language:',
  view_api_docs: 'Access the documentation',
  trigger_hint: 'To see the API working',
  test_it_out: 'Try it',
  clear_output: 'Clean the console'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/affiliate_api.js
// module id = 710
// module chunks = 0